import React from 'react';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Checkbox, Popup, Icon, Button, Grid, Dropdown, Modal } from 'semantic-ui-react';
import {version, buildno} from '../../../package.json';

import Utils from 'utils/Utils.js';
import {colors, fontSizes, fonts, spacings, layout, buttons} from 'style';
import ChangePasswordModalContainer from './ChangePasswordModalContainer.js';

var style= {
    container: {
        height:'100%', 
        ...fonts.body,
        lineHeight: '1.5',
        color: colors.themeDarkerGrey,
    },
    body: {
        marginLeft: 'auto',
        marginRight: 'auto',
        padding: spacings.base,
        maxWidth: layout.screenWidth,    
        boxShadow: layout.screenShadow,
        backgroundColor: 'white',
    },
    grid: {
        padding: '15px 0px 15px 0px',
    },
    row: {
        margin: '0',
        paddingTop:    spacings.tiny,
        paddingBottom: spacings.tiny,
        paddingLeft:  '0',
        paddingRight: '0',
        borderBottom: '1px solid ' + colors.themeGrey,
    },
    column: {
        margin: '0',
        padding: '0',
    },
    partition: {
        display: 'block',
        textAlign: 'left',
        color: '#000',
        backgroundColor: colors.themeGrey,
        height: '20px',
        lineHeight: '0px',
        fontWeight: 'bold',
        paddingLeft:  spacings.tiny,
        paddingRight: spacings.tiny,
    },
    radio: {
        float:'right'
    },
    segment: {
        margin: '0',
        paddingTop:    spacings.tiny,
        paddingBottom: spacings.tiny,
        paddingLeft:  spacings.tiny,
        paddingRight: spacings.tiny,
    },
    contentDiv: {
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    isVerified: {
        float: 'right',
    },
    unverified: {
        cursor: 'pointer',
    },
    editable: {
        color: colors.themeBlue,
    },
    clickable: {
        cursor: 'pointer',
    },
    terms: {
        fontWeight: 'bold',
    },
    logoutButton: {
        backgroundColor: '#fff',
        color: colors.errorRed,
        ...fonts.body,
        lineHeight: '1.5',
    },
    logo: {
        display: 'block',
        textAlign: 'center',
        fontSize: fontSizes.h1,
        color: colors.themeBlue,
    },
    version: {
        opacity: '0.75',
        color: colors.themeBlue,
        textAlign: 'center',
    },
    borderless: {
        borderBottom: 'none',
        borderTop: 'none',
        borderRight: 'none',
        border: 'none',
    },
    modalText: {
        textAlign: 'center',
        padding: spacings.base,
        fontSize: fontSizes.h4,
    },
    modalButton: {
        ...buttons.long,
        marginLeft: 'auto',
        marginRight: 'auto',
        display: 'block',
        marginTop: spacings.base,
    },
    passwordButton: {
        ...buttons.long,
        marginLeft: 'auto',
        marginRight: 'auto',
        display: 'block',
    }
};

const Settings = ({t, 
                   userProfile, 
                    anonymous,  
                    weeklyReportEnabled, 
                    birthDate, 
                    languageOptions, 
                    selectedLanguage, 
                    showVerificationModal,
                    showPasswordChangeModal,
                    verificationEmailState, 
                    onEditUser, 
                    onEditGroup, 
                    onSignOut, 
                    onChangeAnonymous, 
                    onChangeWeeklyReportEnabled, 
                    onChangeLanguage, 
                    onClickUnverified, 
                    onClickChangePassword, 
                    onClickSendVerificationEmail, 
                    onCloseVerificationModal,
                    onCloseChangePasswordModal}) => (
    <div style={style.container}>
        <div style={style.body}>
            <Grid style={style.grid} columns={1} centered>
                <Grid.Row style={style.partition}>
                    {t('Personal Information')}
                </Grid.Row>
                <Grid.Row style={style.row}>
                    <Grid.Column style={style.column} verticalAlign='middle' textAlign='left'>
                        <div style={style.segment}>
                            <div className="bold">{t('Account')}</div>
                            <div style={style.isVerified}>
                                {Boolean(userProfile.emailVerified) &&
                                    <div>
                                        {t('verified')} <Icon className="icon icon-checkmark" />
                                    </div>
                                }
                                {!Boolean(userProfile.emailVerified) &&
                                    <div style={style.unverified} onClick={onClickUnverified}>
                                        {t('unverified')} <Icon className="icon icon-question" />
                                    </div>
                                }
                            </div>
                            <div style={style.contentDiv}>{userProfile.email}</div>
                        </div>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row style={{...style.row, ...style.clickable}} onClick={onEditUser}>
                    <Grid.Column style={style.column} verticalAlign='middle' textAlign='left'>
                        <div style={style.segment}>
                            <div className="bold">{t('Name')}</div>
                            <div style={{...style.contentDiv, ...style.editable}}>{userProfile.firstName} {Utils.limitTo(userProfile.lastName, 1)}</div>
                        </div>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row style={{...style.row, ...style.clickable}} onClick={onEditUser}>
                    <Grid.Column style={style.column} verticalAlign='middle' textAlign='left'>
                        <div style={style.segment}>
                            <div className="bold">{t('Birthday')}</div>
                            <div style={{...style.contentDiv, ...style.editable}}>{birthDate}</div>
                        </div>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row style={style.row}>
                    <Grid.Column style={style.column} verticalAlign='middle' textAlign='left'>
                        <div style={style.segment}>
                            <div className="bold">{t('Anonymous')} 
                                <Popup on='click' wide='very' trigger={<Icon circular size='small' name='info' color='blue' style={{marginLeft: '5px'}} />} >
                                    {t('anon_mode_info')}
                                </Popup>
                            <div style={style.radio}><Checkbox toggle checked={anonymous} onChange={onChangeAnonymous}/></div></div>
                        </div>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row style={style.row}>
                    <Grid.Column style={style.column} verticalAlign='middle' textAlign='left'>
                        <div style={style.segment}>
                            <div className="bold">{t('weekly_report_email')} 
                                <Popup on='click' wide='very' trigger={<Icon circular size='small' name='info' color='blue' style={{marginLeft: '5px'}} />} >
                                    {t('weekly_report_email_info')}
                                </Popup>
                                
                                <div style={style.radio}>
                                    { userProfile.emailVerified ? <Checkbox toggle 
                                              checked={weeklyReportEnabled} 
                                              onChange={onChangeWeeklyReportEnabled} /> :
                                    <Popup on='hover' wide='very' trigger={<Checkbox toggle 
                                              checked={false} 
                                              disabled={true}/>}>
                                        {t('verified_email_required')}
                                    </Popup> }
                                    
                                </div>
                            </div>
                        </div>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row style={style.row}>
                    <Grid.Column style={style.column} verticalAlign='middle' textAlign='left'>
                        <div style={style.segment}>
                            <Button style={style.passwordButton} onClick={onClickChangePassword} >
                                {t('change_password')}
                            </Button>
                        </div>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row style={style.partition}>
                    {t('Company Information')}
                </Grid.Row>
                <Grid.Row style={style.row}>
                    <Grid.Column style={style.column} verticalAlign='middle' textAlign='left'>
                        <div style={style.segment}>
                            <div className="bold">{t('Team')}</div>
                            <div style={style.contentDiv}>{userProfile.team.name}</div>
                        </div>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row style={{...style.row, ...style.clickable}} onClick={onEditGroup}>
                    <Grid.Column style={style.column} verticalAlign='middle' textAlign='left'>
                        <div style={style.segment}>
                            <div className="bold">{t('Current Group')}</div>
                            <div style={{...style.contentDiv, ...style.editable}}>{userProfile.company.name}</div>
                        </div>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row style={style.partition}>
                    {t('Language')}
                </Grid.Row>
                <Grid.Row style={style.row}>
                    <Grid.Column style={style.column} verticalAlign='middle' textAlign='left'>
                        <div style={style.segment}>
                            <div>
                                <Dropdown placeholder={t('Auto-Detect Language')} options={languageOptions} value={selectedLanguage} onChange={onChangeLanguage} selection closeOnChange />
                            </div>
                        </div>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row style={style.partition}>
                    {t('About')}
                </Grid.Row>
                <Grid.Row style={style.row}>
                    <Grid.Column style={style.column} verticalAlign='middle'>
                        <div style={{...style.segment, ...style.terms}}>
                            <a href="https://myoptimity.com/privacy" target="_blank" className="ui link">{t('Privacy Policy')}</a>
                        </div>
                        <div style={{...style.segment, ...style.terms}}>
                            <a href="https://myoptimity.com/terms" target="_blank" className="ui link">{t('Terms of Use')}</a>
                        </div>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row style={{...style.row, ...style.borderless}} verticalAlign='bottom'>
                    <Grid.Column style={style.column} verticalAlign='middle' textAlign='left'>
                        <div className="full-width">
                            <Button style={style.logoutButton} fluid onClick={onSignOut}>{t('Logout')}</Button>
                        </div>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <i style={style.logo} className='icon-myHealthSphere-logo' />
            <br />
            <br />
            <div style={style.version}>
                {t('version_info', {version, buildno})}
            </div>
        </div>

        {Boolean(showVerificationModal) &&
            <Modal open onClose={onCloseVerificationModal} closeIcon>
                <Modal.Header>{t('account-verification')}</Modal.Header>    
                <Modal.Content>
                    <div style={style.modalText}>
                        {Boolean(verificationEmailState==='unsent') &&
                            t('verification-modal-text')
                        }
                        {Boolean(verificationEmailState==='sending') &&
                            t('verification-modal-text-sending')
                        }
                    </div>

                    {Boolean(verificationEmailState==='unsent') &&
                        <Button style={style.modalButton} onClick={onClickSendVerificationEmail}>{t('send-verification-email')}</Button>
                    }
                </Modal.Content>
            </Modal>
        }
        {Boolean(showPasswordChangeModal) &&
            <ChangePasswordModalContainer onClose={onCloseChangePasswordModal} />
        }
    </div>
);

export default translate('settings')(Settings);



// WEBPACK FOOTER //
// ./src/modules/settings/Settings.js